module.exports = __webpack_public_path__ + "assets/glyphicons-halflings-regular-448c34.woff2";


/*****************
 ** WEBPACK FOOTER
 ** F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/~/bootstrap/dist/fonts/glyphicons-halflings-regular.woff2
 ** module id = 910
 ** module chunks = 2
 **/